<template>
  <div>
    <el-page-header @back="goBack" style="margin:10px" content="公告详情">
    </el-page-header>
    <hr />
    <el-form
      style="margin-left:5%;height:600px;overflow-y:scroll"
      :model="infoData"
      label-width="130px"
    >
      <el-form-item label="公告标题:">
        <span style="width:80%">{{
          infoData.documentContent.notificationTitle || ''
        }}</span>
      </el-form-item>
      <el-form-item label="发布人:">
        <span style="width:80%">{{
          infoData.documentContent.publisher || ''
        }}</span>
      </el-form-item>
      <el-form-item label="发布时间:">
        <span style="width:80%">{{
          $Common.dateFormatDate(infoData.documentContent.releaseTime)
        }}</span>
      </el-form-item>
      <el-form-item label="红头:">
        <span style="width:80%">{{
          infoData.documentContent.redHead || ''
        }}</span>
      </el-form-item>
      <el-form-item label="公告内容:">
        <span style="width:80%">{{
          infoData.documentContent.notificationContent || ''
        }}</span>
      </el-form-item>
      <el-form-item label="附件:">
        <div
          class="file"
          style="width:80%"
          v-for="(item, index) in infoData.annex"
          :key="index"
          @click="$Common.fileDownloads(item.attachmentPath)"
        >
          {{ item.attachmentPath.split('/').pop() || '' }}
        </div>
      </el-form-item>
      <el-form-item label="阅读详情:">
        <el-button type="primary" size="small" plain @click="checkInfo"
          >查看</el-button
        >
      </el-form-item>
    </el-form>
    <el-dialog
      class="dialog"
      :append-to-body="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="阅读详情"
      width="520px"
      :visible.sync="showCherkList"
    >
    <el-table style="margin:10px" height="500px" :data="checkData">
      <el-table-column label="序号" type='index' width="60"></el-table-column>
      <el-table-column label="用户昵称" width="220px" prop="userName"></el-table-column>
      <el-table-column label="状态" width="220px" prop="status"></el-table-column>
    </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ImprovingNoticeInfo',
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      infoData: {
        documentContent: {
          id: '',
          notificationTitle: '',
          publisher: '',
          releaseTime: '',
          redHead: '',
          notificationContent: '',
        },
        annex: [],
      },
      showCherkList: false,
      checkData: [],
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      let self = this
      let res = await self.$Http.getAnnouncementsInfo({ id: self.id })
      if (res.code == 200) {
        self.infoData = res.data
      } else {
        self.$message({
          type: 'error',
          duration: 2000,
          message: '当前公告获取失败,暂无法展示！',
        })
        setTimeout(function() {
          self.goBack()
        }, 2000)
      }
    },
    goBack() {
      this.$emit('goBack')
    },
    checkInfo() {
      this.getCheckInfo()
      this.showCherkList = true
    },
    async getCheckInfo() {
      let res = await this.$Http.getReaderDetails({ id: this.id })
      if (res.code == 200) {
        this.checkData = res.data
      } else {
        this.$message({
          type: 'error',
          message: '当前公告阅读详情获取失败',
        })
        this.checkData = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.file {
  cursor: pointer;
}
</style>
